// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_t6-0";